export enum MonthEndProcessStatus {
  Pending = 1,
  Running = 2,
  Completed = 3,
  Failed = 4,
}
